export const isAllValuesDefined = (...values) =>
    values.every(x => typeof x != "undefined");

export const isAllPropsDefined = obg => isAllValuesDefined(Object.keys(obg));
